module.exports = __webpack_public_path__ + "img/4-4.7dda08fa.svg";